import { useEffect, useState } from "react";

import PropTypes from "prop-types";

import PublishSettings from "./PublishSettings";

const PublishSchedulePane = ({
  onPublish,
  onClose,
  isSubmitting,
  datetime,
  isOpen,
  previewProps,
}) => {
  const [datetimeValue, setDatetimeValue] = useState(datetime);

  useEffect(() => {
    setDatetimeValue(datetime);
  }, [datetime]);

  return (
    <PublishSettings
      {...{
        datetimeValue,
        isOpen,
        isSubmitting,
        onClose,
        onPublish,
        previewProps,
        setDatetimeValue,
      }}
    />
  );
};

PublishSchedulePane.propTypes = {
  onPublish: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  datetime: PropTypes.string,
  isOpen: PropTypes.bool,
  previewProps: PropTypes.shape({
    coverImageUrl: PropTypes.string,
    title: PropTypes.string,
    publicUrl: PropTypes.string,
  }),
};

export default PublishSchedulePane;
